import type {RouteNames, RouteResult} from 'src/types';

/**
 * @see https://trailhead.corp.stripe.com/docs/sail-navigation/api/isRouteResult
 */
export default function isRouteResult<T extends RouteNames>(
  /** The route object to check, typically from the useRoute hook */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  route: any,
  /** The route name to check against */
  name: T,
): route is RouteResult<T> {
  if (route && typeof route === 'object' && 'name' in route) {
    return route.name === name;
  }
  return false;
}
